var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSharedChannelRightChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.09766 16.8584L6.57266 18.3334L14.906 10L6.57266 1.66669L5.09766 3.14169L11.956 10L5.09766 16.8584Z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgICA8cGF0aCBkPSJNNS4wOTc2NiAxNi44NTg0TDYuNTcyNjYgMTguMzMzNEwxNC45MDYgMTBMNi41NzI2NiAxLjY2NjY5TDUuMDk3NjYgMy4xNDE2OUwxMS45NTYgMTBMNS4wOTc2NiAxNi44NTg0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+DQo8L3N2Zz4NCg==";
export { SvgSharedChannelRightChevron as ReactComponent };